import React from 'react';
//import Menu from '../../Menu';
import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setMenu} from '../actionCreators';
import Menu from '../components/Menu';
import Scheduler from '../components/Scheduler';
import Modal from '../components/Modal';

class Schedule extends BasePage {

    loadOnConstructor(){

    	this.state = {};
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.getTrad('schedule')}</h3>
                <div className="row mt-4">
                    <div className="col-12">
                	<Scheduler />
                    </div>
                </div>

	    <Modal/>
            </div>
        );
    }
}

const mapStatToProps = state => {
    return {
        menu: state.menu
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setMenu(menu){
            dispatch(setMenu(menu));
        }
    }
}

export default connect(mapStatToProps, mapDispatchToProps)(Schedule)
